module.exports = __webpack_public_path__ + "static/media/main.b1edb122.png";